import { useEffect, useState } from 'react';

function useClientHydrated() {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  return hydrated;
}

export default useClientHydrated;
